<template>
    <div :class="isPC?'answer-section':'pcanswer-section'">
        <!-- 有奖问答 -->
        <div class="answerList" v-show="isShowAnswerAssembly==1">
            <div class="answer-header">
                <p>有奖问答</p><img src="../../assets/img/close_icon.png" alt="" @click='closeRank'>
            </div>
            <div class="main">
                <div class="main-title">{{winninganswer.title}}-{{winninganswer.type==1?'（单选）':'（多选）'}}</div>
                <ul>
                    <li 
                    @click="winninganswer.type==1?SelectAnswer(item,index,String.fromCharCode(index + 65)):MultipleAnswer(item,index,String.fromCharCode(index + 65))" 
                    :class='{"main-sec-active":SelectAnswerTab.includes(index)}'
                    v-for="(item,index) in anslist" :key="'answer-index'+index"> 
                    {{ String.fromCharCode(index + 65) }}.{{item.content}}
                    </li>
                </ul>
            </div>
            <div class="answer-sublimt"><span @click='sublimtAnswerEliminate?sublimtAnswer():""'>提交<i v-show='countDounNum'>({{countDounNum}})</i></span></div>
        </div>
        <!-- 答题正确 -->
        <div v-show='isShowAnswerAssembly == 2' class='sure-answer-box'>
            <div class='top_img_box'></div>
            <div class='answer-correct'>回答正确</div>
            <div class='answer-first'>战胜99%的用户</div>
            <div class='information_box'>
                <div class='information_box_left'>
                    <p class='p_1'>{{nowRanking.ranking}}</p>
                    <p class='p_2'>当前排名</p>
                </div>
                <div class='information_box_right'>
                    <p class='p_1'>{{nowRanking.current_time}}</p>
                    <p class='p_2'>本题用时</p>
                </div>
            </div>
            <div class='explain_box'>
                <div class='explain_box_title'>
                    <img src="../../assets/img/zs_left.png" alt=""><span>正在为您登记排名，请填写以下信息</span><img src="../../assets/img/zs_left.png" alt="">
                </div>
                <div class='form_box'>
                    <van-field
                    v-model="prizeMsg.member_num"
                    type="text"
                    name="会员编码"
                    label="会员编码"
                    placeholder="请输入会员编码"
                    />
                    <van-field
                    v-model="prizeMsg.name"
                    type="text"
                    name="姓名"
                    label="姓名"
                    placeholder="请输入姓名"
                    />
                </div>
            </div>
            <div class='answer-sublimt'><span @click='sublimtVipEliminate?sublimtVip():""'>提交</span></div>
        </div>
        <!-- 排行榜 -->
        <div v-show='isShowAnswerAssembly == 3' class='rankAnswer'>
            <div class='rank_title'>
                <p class='rank_header'><img src="../../assets/img/jb_top_img.png" alt="">排行榜</p>
                <img src="../../assets/img/close_icon.png" alt="" class='close_box' @click="closeRank">
            </div>
            <div class='rank_list_box'>
                <ul>
                    <li class='rank_list_title'><p class='rank_ranking'>排名</p><p class='rank_name'>昵称</p><p class='rank_time'>用时</p></li>
                    <li class='rank-list' v-for='(item,index) in rankingList' :key="'rank_list_'+index">
                        <p class='rank_ranking'>
                            <img src="../../assets/img/1.png" alt="" v-show='index == 0'>
                            <img src="../../assets/img/2.png" alt="" v-show='index == 1'>
                            <img src="../../assets/img/3.png" alt="" v-show='index == 2'>
                            {{index >2 ?item.ranking:''}}
                        </p>
                        <p class='rank_name'>{{item.name ? item.name : item.nickname }}</p>
                        <p class='rank_time'>{{item.use_time}}</p>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 答题错误 -->
        <div class='errorBox' v-show='isShowAnswerAssembly == 4'>
            <div class='errorBox-title-img'><img src="../../assets/img/error_top_img.png" alt=""></div>
            <div class='error-msg'>继续努力哦</div>
            <div>
                <div class="error-main-title">{{winninganswer.title}}-{{winninganswer.type==1?'（单选）':'（多选）'}}</div>
                <ul class='error-main'>
                    <li 
                    :class="!item.is_right?'AnswerError':''" 
                    v-for="(item,index) in anslist" 
                    :key="'answer-index'+index"> 
                        {{ String.fromCharCode(index + 65) }}.{{item.content}}
                        <img src='../../assets/img/correct_icon.png' v-show='item.is_right'>
                        <img src='../../assets/img/error_icon.png' v-show='!item.is_right'>
                    </li>
                </ul>
            </div>
            <div class='answer-sublimt' @click='lookRanking'><span>查看排行榜</span></div>

        </div>
        <!-- 总排行榜 -->
        <div v-show='isShowAnswerAssembly == 5' class='rankAnswer'>
            <div class='rank_title'>
                <p class='rank_header'><img src="../../assets/img/jb_top_img.png" alt="">排行榜</p>
                <img src="../../assets/img/close_icon.png" alt="" class='close_box' @click="closeRank">
            </div>
            <div class='rank_list_box'>
                <ul>
                    <li class='rank_list_title'><p class='rank_ranking'>排名</p><p class='rank_name'>昵称</p><p class='rank_CorrectRate'>正确率</p><p class='rank_time'>用时</p></li>
                    <li class='rank-list' v-for='(item,index) in totalRankList' :key="'rank_list_'+index">
                        <p class='rank_ranking'>
                            <img src="../../assets/img/1.png" alt="" v-show='index == 0'>
                            <img src="../../assets/img/2.png" alt="" v-show='index == 1'>
                            <img src="../../assets/img/3.png" alt="" v-show='index == 2'>
                            {{index >2 ?index+1:''}}
                        </p>
                        <p class='rank_name'>{{ item.name ? item.name : item.nickname}}</p>
                        <p class='rank_CorrectRate'>{{item.percent}}</p>
                        <p class='rank_time'>{{item.total_use_time}}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { mapState, mapActions } from 'vuex'
export default {
    props:['winninganswer','isShowAnswerRankingList','totalRankList'],
    data () {
        return {
            anslist:[], //问答列表
            SelectAnswerTab:[], //单选、多选 css样式
            isShowAnswerAssembly:1 ,// 1:答题组件 2:答题正确 3:排行榜 4:回答错误
            prizeMsg:{
                name:"", //会员姓名
                member_num:"" //会员编码
            },
            choiseAnsoer:[], //选中的data
            choiseAnsoerRadio:{}, //选中的单选data
            nowRanking:{},//当前排名
            rankingList:[] ,//排行榜
            answerContent:'', //选中的content
            answerStatus:false, //判读是否回答正确
            answerTimer:null, //倒计时
            countDounNum:0, //倒计时秒数
            optionContent:"" ,//单选选项 A B
            optionContentMulti:[], //多选 的a 、b
            sublimtAnswerEliminate:true, //提交答题防抖
            sublimtVipEliminate:true, //答对，提交会员信息防抖
            isPC:false, //false=pc
        }
    },
    created(){
        this.isPC = this.isMobile()
    },
    mounted(){
        // console.log(this.hosturl)
    },
    methods:{
        initTimer(){ //倒计时
            if(this.winninganswer.time){
                // let nowTime = parseInt((new Date().getTime() - this.winninganswer.sentOutDate) / 1000)
                let num = parseInt(this.winninganswer.time) //答题倒计时
                this.countDounNum = num
                this.countDown()
            }
        },
        countDown(){ //倒计时
            if(this.answerTimer == null){
                this.answerTimer = setInterval(() => {
                    if (this.countDounNum <= 0) {
                        clearInterval(this.answerTimer)
                        if(this.isShowAnswerAssembly == 1 || this.isShowAnswerAssembly == null){
                            this.closeRank()
                            clearInterval(this.answerTimer)
                        }
                        this.answerTimer = null
                    } else {
                        this.countDounNum = this.countDounNum -1
                    }
                }, 1000)
            }
        },
        SelectAnswer(item,index,optionContent){ //单选
            this.optionContent = ''
            this.choiseAnsoerRadio = item
            this.SelectAnswerTab = [index]
            this.optionContent = optionContent
            // console.log(item)
        },
        MultipleAnswer(item,index,optionContent){ // 多选
            // css
            if(this.SelectAnswerTab.includes(index)){
                this.SelectAnswerTab=this.SelectAnswerTab.filter(function (ele){return ele != index;});
            }else{
                this.SelectAnswerTab.push(index)
            }
            //js
            if(this.choiseAnsoer.includes(item)){
                this.choiseAnsoer=this.choiseAnsoer.filter(function (ele){return ele != item;});
            }else{
                this.choiseAnsoer.push(item)
            }
            if(this.optionContentMulti.includes(optionContent)){
                this.optionContentMulti=this.optionContentMulti.filter(function (ele){return ele != optionContent;});
            }else{
                this.optionContentMulti.push(optionContent)
            }
            
        },
        closeRank(){ //关闭排行榜 、关闭答题
            clearInterval(this.answerTimer)
            this.anslist = []
            this.SelectAnswerTab = []
            this.choiseAnsoer = []
            this.nowRanking = {}
            this.rankingList = []
            this.answerContent = false
            this.answerTimer = null, //倒计时
            this.countDounNum = 0
            this.isShowAnswerAssembly = null
            this.optionContent = []
            this.$emit('closeprizeQA')
            this.$emit('changetypepage',null)
        },
        lookRanking(){ //查看排行榜
            this.isShowAnswerAssembly = 3
            this.$emit('changetypepage',3)
        },
        sublimtAnswer(){ //提交问答
            let _that = this
            if(_that.winninganswer.type == 1){ //单选
                _that.submitRadio()
            }
            if(_that.winninganswer.type == 2){ //多选
            console.log(_that.winninganswer)
                _that.submitMulti()
            }
            // console.log(_that.answerContent)
        },
        submitRadio(){ //单选
            let _that = this
            if(_that.choiseAnsoerRadio.id){
                if(_that.choiseAnsoerRadio.is_right){ //单选，选中正确
                    _that.answerContent = ''
                    _that.answerContent = _that.optionContent+'.'+ _that.choiseAnsoerRadio.content
                    _that.sublimtAnswerEliminate = false
                    _that.answerStatus = true
                    this.getRankFn()
                    console.log(_that.optionContent)
                }else{ //选中错误
                    _that.sublimtAnswerEliminate = false
                    let params = {
                        quiz_id: _that.winninganswer.id,
                        content:_that.optionContent+'.'+ _that.choiseAnsoerRadio.content,
                        start_time: _that.winninganswer.sentOutDate,
                        is_right: false,
                        optionContent:_that.optionContent
                    }
                    _that.answerError(params)
                }
            }else{
                Toast('至少选择一个！')
            }
        },
        submitMulti(){ //多选
            let _that = this
            if(this.choiseAnsoer.length){
                let answerOption = _that.winninganswer.quiz_option.filter(function (item) {
                    return item.is_right
                }) //正确答案集合
                _that.choiseAnsoer = _that.choiseAnsoer.sort(function (a, b) { return a.id - b.id })
                _that.optionContentMulti =  _that.optionContentMulti.sort(function (a, b){
                    let x1 = a.toUpperCase();
                    let x2 = b.toUpperCase();
                    if (x1 < x2) {return -1;}
                    if (x1 > x2) {return 1;}
                    return 0;
                })
                _that.answerContent = ''
                _that.choiseAnsoer.forEach((item,index) =>{
                    _that.answerContent += _that.optionContentMulti[index]+'.'+item.content + ' '
                })
                _that.optionContent = _that.optionContentMulti.join(",")
                if(answerOption.length == this.choiseAnsoer.length){ 
                    _that.answerStatus = _that.choiseAnsoer.every(_that.isRightFn)
                    if(_that.answerStatus){//回答正确
                        _that.answerStatus = true
                        _that.sublimtAnswerEliminate = false
                        _that.getRankFn()
                    }else{
                        let params = {
                            quiz_id: _that.winninganswer.id,
                            content:_that.answerContent,
                            start_time: _that.winninganswer.sentOutDate,
                            is_right: false,
                            optionContent:_that.optionContent
                        }
                        _that.answerError(params)
                    }
                }else{
                    let params = {
                        quiz_id: _that.winninganswer.id,
                        content:_that.answerContent,
                        start_time: _that.winninganswer.sentOutDate,
                        is_right: false,
                        optionContent:_that.optionContent
                    }
                    _that.answerError(params)
                }
            }else{
                Toast('至少选择一个！')
            }
        },
        answerError(params){ //回答错误
            let _that = this
            _that.$http({
                url:`${_that.hosturl}/award_quiz/adm_response_error/`,
                method:'post',
                data:params
            }).then(res => {
                let data = res.data
                console.log(data)
                if(data.code == 200){
                    _that.sublimtAnswerEliminate = true
                    this.rankingList = data.result
                    this.isShowAnswerAssembly = 4
                    this.SelectAnswerTab = []
                }else{
                    _that.sublimtAnswerEliminate = true
                    Toast(data.msg)
                }
            }).catch(error => {
                 _that.sublimtAnswerEliminate = true
                Toast('报错啦')
            })
        },
        isRightFn(element, index, array){
            return element.is_right
        },
        getRankFn(){ //回答正确 获取排名
            let _that = this
            _that.$http(`${_that.hosturl}/award_quiz/user_ranking/${_that.winninganswer.id}/`).then(res => {
                let data = res.data
                console.log(data)
                var localAdmName = window.localStorage.getItem('admName')
                var localAdmMember = window.localStorage.getItem('admMember_num');
                if(localAdmName && localAdmMember){
                    this.prizeMsg.name = localAdmName
                    this.prizeMsg.member_num = localAdmMember
                }
                if(data.code == 200){
                    _that.sublimtAnswerEliminate = true
                    _that.nowRanking = data.result
                    _that.nowRanking.current_time = ((data.result.current_time - _that.winninganswer.sentOutDate) / 1000).toFixed(2)  //答题时长
                    _that.isShowAnswerAssembly = 2 //回答正确 
                    this.$emit('changetypepage',2)
                }else{
                    _that.sublimtAnswerEliminate = true
                    Toast(data.msg)
                }
            }).catch(error => {
                _that.sublimtAnswerEliminate = true
                Toast('报错啦')
            })
        },
        sublimtVip(){ //回答正确后，提交vip信息
            console.log(this.sublimtVipEliminate)
            if(this.prizeMsg.name && this.prizeMsg.member_num){
                this.sublimtVipEliminate = false
                window.localStorage.setItem('admName', this.prizeMsg.name);
                window.localStorage.setItem('admMember_num', this.prizeMsg.member_num);
                let params = {
                    quiz_id: this.winninganswer.id,
                    content: this.answerContent,
                    use_time: this.nowRanking.current_time,
                    is_right: this.answerStatus,
                    ranking: this.nowRanking.ranking,
                    name: this.prizeMsg.name,
                    member_num: this.prizeMsg.member_num,
                    optionContent:this.optionContent,
                    nickname: this.prizeMsg.name
                }
                console.log(params)
                this.$http({
                    url:`${this.hosturl}/award_quiz/adm_response_right/`,
                    method:'post',
                    data:params
                }).then(res => {
                    let data = res.data
                    console.log(data)
                    if(data.code == 200){
                        this.rankingList = data.result
                        this.isShowAnswerAssembly = 3
                        this.$emit('changetypepage',3)
                        this.sublimtVipEliminate = true
                        this.optionContent = []
                        this.choiseAnsoer = []
                        this.SelectAnswerTab = []
                        
                        this.optionContentMulti = []
                    }else{
                        this.sublimtVipEliminate = true
                    }
                }).catch(error => {
                    this.sublimtVipEliminate = true
                    Toast('报错啦')
                })
            }else{
                this.sublimtVipEliminate = true
                Toast('请填写会员信息！')
            }
        },
        isMobile() {
            var e = navigator.userAgent.toLowerCase()
            var t = /iPhone|iPad|iPod/i.test(e),
                n = /Android/i.test(e),
                r = /Windows Phone/i.test(e) || /IEMobile/i.test(e) || /WPDesktop/i.test(e),
                a = /BlackBerry/i.test(e),
                o = /Opera Mini/i.test(e);
            return t || n || r || a || o || (this.isWeixinBrowser && (window.innerWidth < 768))
        },
    },
    
    watch:{
        winninganswer(val){
            // console.log(val)
            this.isShowAnswerAssembly = 1
            this.$emit('changetypepage',1)
            this.winninganswer = val
            this.anslist = val.quiz_option
            this.initTimer()
        },
        isShowAnswerRankingList(val){
            console.log(this.totalRankList)
            this.isShowAnswerAssembly = 5
            this.$emit('changetypepage',5)
        }
    },
    computed: {
        ...mapState({
            hosturl :state => state.global.baseUri,
            baseurlJson :state => state.global.baseurlJson,
        })
    }
}
</script>
<style scoped lang="scss">
    // 省略号
    @mixin ellipsis($num){
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: $num;
        line-clamp: $num;
        -webkit-box-orient: vertical;
    }
    .answer-section{
        position:fixed;
        width:100%;
        height:calc(100% - 56.25vw);
        left:0;
        top:56.25vw;
        background:rgba(51,51,51,.3);
        display:flex;
        align-items:start;
        justify-content:center;
        z-index: 2001;
        overflow-y: scroll;
        padding-top:.46rem;
    }
    .pcanswer-section{
        position:fixed;
        width:100%;
        height:100%;
        left:0;
        top:0;
        background:rgba(51,51,51,.3);
        display:flex;
        align-items:center;
        justify-content:center;
        z-index: 2001;
        overflow-y: scroll;
        padding-top:.46rem;
    }
    .answerList{
        max-width:3.2rem;
        width: 90%;
        background:#ffffff;
        border-radius:.04rem;
    }
    .answer-header{
        position:relative;
        text-align: center;
        box-shadow: 0rem 0rem 0.3rem 0rem rgb(51 75 255 / 10%);
        p{
            font-size:.14rem;
            color:#333333;
            line-height:.4rem;
        }
        img{
            width:.16rem;
            height:.16rem;
            position:absolute;
            right:.2rem;
            top:.14rem;
        }
    }
    .main{
        padding:.1rem;
        // height:2.4rem;
        ul{
            max-height:2rem;
            overflow-y:scroll;
        }
        .main-title{
            margin-bottom:.1rem;
            color:#333333;
        }
        li{
            // line-height:.rem;
            border:.01rem solid #d9ddff;
            margin-bottom:.1rem;
            padding:.1rem;
            color:#333333;
        }
        .main-sec-active{
            background:rgba(25, 148, 255, 0.1);
            border:.01rem solid #37a3ff;
        }
    }
    .answer-sublimt{
        padding:.1rem;
        box-sizing: border-box;
        span{
            display:inline-block;
            background:linear-gradient(0deg, #33a0ff 0%, #0088ff 100%);
            line-height:.3rem;
            width:100%;
            border-radius:.15rem;
            text-align:center;
            color:#ffffff;
        }
    }
    // 回答正确
    .sure-answer-box{
        max-width:3.3rem;
        width:85%;
        // min-height:4rem;
        background:linear-gradient(0deg, #5b42bb, #5c6df3);
        border-radius: .1rem;
        text-align:center;
        .top_img_box{
            background:url('../../assets/img/gxn_top_img.png');
            width:1.76rem;
            height:.74rem;
            background-size:100% 100%;
            margin-top:-.4rem;
            display:inline-block;
        }
        .answer-correct{
            font-size:.18rem;
            color:#ffffff;
            font-weight:600;
        }
        .answer-first{
            margin:.1rem 0;
            font-size:.14rem;
            color:#ffffff;
            font-weight: 400;
        }
        .information_box{
            display:flex;
            align-items: center;
            justify-content: space-around;
            margin-top:.14rem;
        }
        .p_1{
            font-size:.18rem;
            margin-bottom:.18rem;
            color:#fece72;
        }
        .p_2{
            color:#ffffff;
            font-size:.12rem;
        }
        .explain_box_title{
            color:#ffffff;
            font-size:.12rem;
            display:flex;
            line-height:.4rem;
            padding: .1rem;
            box-sizing: border-box;
            align-items: center;
            justify-content:center;
        }
        .explain_box_title span{
            margin:0 .1rem;
            display:inline-block;
            max-width: 80%;
            @include ellipsis(1);
        }
        .explain_box_title img{
            width:.2rem;
            vertical-align: middle;
        }
        .form_box{
            padding:.0rem .1rem .1rem .1rem;
            &>>>.van-cell{
                background:none;
            }
            &>>>.van-field__label{
                color:#ffffff;
                width:.5rem;
            }
            &>>>.van-cell::after{
                border-bottom:none;
            }
            &>>>.van-field__value{
                background:#00000011;
                padding:.04rem .1rem;
                border-radius:.04rem;
            }
            &>>>.van-field__control{
                color:#ffffff;
            }
        }
    }
    // 排行榜
    .rankAnswer{
        max-width:3.3rem;
        width:85%;
        min-height:2rem;
        background:linear-gradient(0deg, #5b42bb, #5c6df3);
        border-radius:.04rem;
        padding:0 0 .1rem 0;
        .rank_title{
            position:relative;
            text-align:center;
            padding:.1rem;
        }
        .rank_header{
            line-height:.3rem;
            color:#ffffff;
            font-size:.16rem;
            font-weight: 600;;
            img{
                width:.4rem;
                vertical-align: middle;
                margin-right:.04rem;
            }
        }
        .rank_list_box{
            li{
                display:flex;
                align-items: center;
                justify-content: space-around;
                text-align: center;
            }
            .rank-list{
                margin-bottom:.14rem;
                p{
                    color:#ffffff;
                }
            }
            li img{
                width:.2rem;
                vertical-align: middle;
            }
            
            li:first-child{
                p{
                    padding:0 0 .1rem 0;
                }
            }
        }
        .rank_list_title{
            p{
                color:#fece72;
            }
        }
        .rank_ranking{
            width:30%;
        }
        .rank_name{
            width:30%;
            @include ellipsis(1)
        }
        .rank_CorrectRate{
            width:30%;
        }
        .rank_time{
            width:30%;
        }
    }
    .close_box{
        width:.2rem;
        height:.2rem;
        position:absolute;
        right:.2rem;
        top:.12rem;
    }
    // 回答错误
    .errorBox{
        max-width: 3.3rem;
        width:85%;
        min-height:2rem;
        background:linear-gradient(0deg, #5b42bb, #5c6df3);
        border-radius:.04rem;
        .errorBox-title-img{
            text-align:center;
            img{
                width:1.5rem;
                margin-top:-.41rem;
            }
        }
        .error-msg{
            text-align:center;
            font-size:.18rem;
            color:#ffffff;
            font-weight:600;
            margin-bottom:.1rem;
        }
        .error-main-title{
            margin-bottom:.1rem;
            color:#ffffff;
            padding:0 .1rem;
            font-size:.14rem;
        }
        .error-main{
            padding:0 .1rem;
            max-height:2rem;
            overflow-y:scroll;
            li{
                line-height:.3rem;
                background:rgba(22, 217, 113, 0.6) ;
                border-radius:.04rem;
                margin-bottom:.1rem;
                padding:0 .1rem;
                color:#ffffff;
                position:relative;
            }
            li img{
                position:absolute;
                width:.16rem;
                height:.16rem;
                right:0;
                bottom:0;
                border-bottom-right-radius: .04rem;
            }
            .AnswerError{
                background:rgba(255, 78, 13, 0.534);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/answer/prizeQA.vue